/***********************************
  Chart Module
************************************/

Quad.Chart = ( function() {

    // PRIVATE VARS
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~

    var chart;

    // PRIVATE METHODS
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~
    function _init( chartID, chartType, config ){

        $('.label-tooltip:first-child').addClass( 'active' );

        var xPad;
        if( chartType === 'doughnut' && window.innerWidth > 767 ){
            xPad = -125;
        } else if( chartType === 'doughnut' && window.innerWidth < 767 ){
            xPad = -75;
        } else {
            xPad = 10;
        }

        var options = {

            responsive: true,
            legend: false,
            showAllTooltips: chartType === 'doughnut' ? true : false,
            tooltips: {
                intersect:       true,
                mode:            'point',
                xPadding:        xPad,
                yPadding:        chartType === 'doughnut' ? 0 : 10,
                backgroundColor: chartType === 'doughnut' ? 'rgba(0,0,0,0)' : '#1c305e',
                titleFontColor:  chartType === 'doughnut' ? '#1c305e' : '#ffffff',
                bodyFontColor:   chartType === 'doughnut' ? '#1c305e' : '#ffffff',
                titleFontFamily: chartType === 'doughnut' ? 'Georgia, Times, "Times New Roman", serif' : 'open-sans, "Segoe UI", Tahoma, sans-serif',
                bodyFontFamily:  chartType === 'doughnut' ? 'Georgia, Times, "Times New Roman", serif' : 'open-sans, "Segoe UI", Tahoma, sans-serif',
                titleFontStyle:  chartType === 'doughnut' ? 'italic' : 'normal',
                bodyFontStyle:   chartType === 'doughnut' ? 'italic' : 'normal',
                titleFontSize:   chartType === 'doughnut' && window.innerWidth > 767 ? 18 : 12,
                bodyFontSize:    chartType === 'doughnut' && window.innerWidth > 767 ? 18 : 12,
                bodySpacing:     0,
                caretSize:       chartType === 'doughnut' ? 0 : 5,
                displayColors:   false,
                cornerRadius:    0,
                callbacks: {
                    label: function(tooltipItem,data){
                        var i           = tooltipItem.index;
                        return data.labels[i];
                    },
                    title: function(tooltipItem,data){
                        return '';
                    }
                }
            },
            onHover: function(evt, item){
                if( chartType === 'doughnut' ){
                    if (item.length){
                        var _label = item[0]._index + 1;
                        $('.label-tooltip').removeClass( 'active' );
                        $( '.label-tooltip[data-label="'+_label+'"]' ).addClass( 'active' );
                    }
                }
            },
            elements: {
                line: {
                    tension: 0
                }
            },
            scales: {
                xAxes: [{
                    gridLines: {
                        drawBorder: chartType === 'doughnut' ? false : true,
                        display: chartType === 'doughnut' || chartType === 'bar' ? false : true
                    },
                    ticks: {
                        display: chartType === 'line' || chartType === 'bar' ? true : false,
                        
                        
                        callback: function( value ){
                            if( chartType === 'line' ){
                                return value.substr( 0,10 );
                            }
                            if( chartType === 'bar' ){
                                return value.substr( 0,8 );
                            }
                        }

                    }
                }],
                yAxes: [{
                    gridLines: {
                        drawBorder: chartType === 'doughnut' ? false : true,
                        display: chartType === 'doughnut' ? false : true
                    },
                    ticks: {
                        display: chartType === 'doughnut' ? false : true,
                        beginAtZero: chartType === 'bar' ? true : false,
                        callback: function(value, index, values) {
                            return '$'+value.toFixed(2);
                        }
                    }
                }]
            }
        };

        var ctx = document.getElementById( 'chart-'+chartID );

        chart = new Chart( ctx, {
            type: chartType,
            data: config,
            options: options,
            plugins: [{
                beforeInit: function (chart){
                    if( chartType === 'doughnut' ){
                        chart.data.labels.forEach(function (e, i, a) {
                            if (/\n/.test(e)) { a[i] = e.split(/\n/); }
                        });
                    }
                }
            }]
        });

    }

    function _update( newLabels, newData ){

        chart.data.labels = newLabels;
        chart.data.datasets[0].data = newData;
        chart.update();

    }
  
  
    // PUBLIC METHODS
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~
    return {
  
      init: _init,
      update: _update
  
    };
  
  })();